export default "<div class=\"th {{align}}\">\n  {{ text }}\n</div>\n"